import styled from '@emotion/styled';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const BreadcrumbsActionsPortal = ({ children }: Props) => {
  return <S.Portal>{children}</S.Portal>;
};

const S = {
  Portal: styled.div`
    position: fixed;
    z-index: 10;
    top: 0;
    right: 0;
    height: 50px;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    margin-right: 0.5rem;
  `,
};
